import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Bonos() {
  return <section className="bg-cream-100 px-5 py-12 sm:py-20" data-id="element-18" data-mp="2ha79knnspx56">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="2lddcblbp966w">
        <SectionHeading eyebrow="Incluidos gratis" title="5 Bonos Estratégicos" subtitle="Sin costo extra — incluidos en el pack" data-id="element-20" data-mp="2q4v9rzeikon4" />

        <ul className="mt-6 grid gap-2 sm:mt-10 sm:grid-cols-2 sm:gap-3" data-id="element-21" data-mp="2v3q520to45o4">
          {bonos.map(bono => <li key={bono.id} className="flex items-center gap-3 rounded-xl bg-cream-50 p-2.5 shadow-card ring-1 ring-inset ring-forest-900/[0.07] transition-transform duration-150 ease-out hover:-translate-y-0.5 sm:gap-4 sm:p-3" data-id="element-22" data-mp="3055oxpk4064x">
              <img src={bono.image} alt={bono.alt} width={320} height={240} loading="lazy" decoding="async" sizes="(max-width: 640px) 60px, 72px" className="h-14 w-14 shrink-0 rounded-lg bg-cream-200 object-cover sm:h-16 sm:w-16" data-id="element-23" data-mp="1appgydhx8qgm" />
              <div className="min-w-0 flex-1" data-id="element-24" data-mp="34der8yu2pgk7">
                <div className="flex items-center gap-2" data-id="element-25" data-mp="34c3ngz0mo8t3">
                  <span className="font-display text-[0.65rem] text-forest-600 sm:text-xs" style={{
                fontWeight: 700
              }} data-id="element-26" data-mp="2zg63miq5okbk">
                    {bono.id}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-forest-600/10 px-1.5 py-0.5 text-[0.5rem] font-bold uppercase tracking-wider text-forest-700 sm:text-[0.55rem]" data-id="element-27" data-mp="3s4k73e00k8ui">
                    <GiftIcon className="h-2.5 w-2.5" aria-hidden="true" data-id="element-28" data-mp="3i5cu4rx6yg7x" /> Gratis
                  </span>
                </div>
                <h3 className="mt-0.5 font-display text-[0.88rem] leading-tight text-forest-900 sm:text-[0.98rem]" style={{
              fontWeight: 600
            }} data-id="element-29" data-mp="26qfqabwclmgi">
                  {bono.title}
                </h3>
                <p className="mt-0.5 line-clamp-2 text-[0.72rem] leading-snug text-forest-900/60 sm:text-[0.78rem]" data-id="element-30" data-mp="12rapmi6ocz5w">
                  {bono.text}
                </p>
              </div>
            </li>)}

          <li className="flex items-center justify-center gap-2.5 rounded-xl bg-forest-800 px-4 py-3 text-center" data-id="element-31" data-mp="tq2q5wsf9sa8">
            <p className="text-[0.6rem] font-bold uppercase tracking-[0.12em] text-gold-400 sm:text-[0.65rem]" data-id="element-32" data-mp="f0wugissmk73">
              Valor total
            </p>
            <p className="font-display text-lg text-cream-50 line-through decoration-gold-400/70 decoration-2 sm:text-xl" style={{
            fontWeight: 700
          }} data-id="element-33" data-mp="63e552849jpe">
              $60.000
            </p>
            <p className="font-display text-lg text-gold-400 sm:text-xl" style={{
            fontWeight: 700
          }} data-id="element-34" data-mp="3sabaiu4d8xpg">
              GRATIS
            </p>
          </li>
        </ul>
      </div>
    </section>;
}